import { DatePipe } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { Injector, NgModule, inject, provideAppInitializer } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MomentDateModule } from "@angular/material-moment-adapter";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { StorageModule } from "@ngx-pwa/local-storage";
import { MissingTranslationHandler, TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { AuthInterceptor } from "./core/interceptors/auth.interceptor";
import { HttpLoader } from "./core/translations/http-loader";
import { MissingHandler } from "./core/translations/missing-handler";
import { AdmissionDateModule } from "./kiosk/components/admission-date/admission-date.module";
import { AgreementModule } from "./kiosk/components/agreement/agreement.module";
import { ArchospiModule } from "./kiosk/components/archospi/archospi.module";
import { AuthenticationModule } from "./kiosk/components/authentication/authentication.module";
import { CardScanModule } from "./kiosk/components/card-scan/card-scan.module";
import { CityModule } from "./kiosk/components/city/city.module";
import { ContractModule } from "./kiosk/components/contract/contract.module";
import { ErrorModule } from "./kiosk/components/error/error.module";
import { HospiModule } from "./kiosk/components/hospi/hospi.module";
import { InsurerModule } from "./kiosk/components/insurer/insurer.module";
import { LanguageModule } from "./kiosk/components/language/language.module";
import { LightModule } from "./kiosk/components/light/light.module";
import { MaintenanceModule } from './kiosk/components/maintenance/maintenance.module';
import { FooterComponent } from "./kiosk/components/master/footer/footer.component";
import { HeaderComponent } from "./kiosk/components/master/header/header.component";
import { MainComponent } from "./kiosk/components/master/main/main.component";
import { StepperModule } from './kiosk/components/master/stepper/stepper.module';
import { StepperComponent } from "./kiosk/components/master/stepper/stepper/stepper.component";
import { PatientModule } from "./kiosk/components/patient/patient.module";
import { ProvinceModule } from "./kiosk/components/province/province.module";
import { QuestionModule } from "./kiosk/components/question/question.module";
import { ScreenSaverModule } from "./kiosk/components/screensaver/screensaver.module";
import { SiteModule } from "./kiosk/components/site/site.module";
import { KioskSpinnerComponent } from "./kiosk/components/spinner/spinner.component";
import { KioskSpinnerModule } from "./kiosk/components/spinner/spinner.module";
import { TitleModule } from './kiosk/components/title/title.module';
import { KioskModule } from "./kiosk/kiosk.module";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { TransactionInfoModule } from "./kiosk/components/transaction-info/transaction-info.module";
import { StoreDevModules } from "src/environments/devtool";
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { ApiModule } from "./api/api.module";
import { ApiModule as AuthenticatorModule } from './authenticator/api.module';
import { DataStorageService } from "assurcard-angular-library";
import { TranslationService } from "./api/services";
import { LanguageInterceptor } from "./core/interceptors/language.interceptor";
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import 'moment/locale/nl';
import 'moment/locale/de';

export function appInitializerFactory(translate: TranslateService) {
	return () => {
		translate.setDefaultLang('en');
		return translate.use('en').toPromise();
	};
}

@NgModule({ declarations: [AppComponent,
        MainComponent,
        HeaderComponent,
        FooterComponent,
        KioskSpinnerComponent,
        StepperComponent,
    ],
    exports: [TranslateModule],
    bootstrap: [AppComponent], imports: [SharedModule, CoreModule,
        MomentDateModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forRoot({
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: MissingHandler,
                deps: [Injector],
            },
            loader: {
                provide: TranslateLoader,
                useClass: HttpLoader,
                deps: [DataStorageService, TranslationService],
            },
        }),
        StorageModule.forRoot({ IDBNoWrap: false }),
        StoreModule.forRoot({}),
        StoreDevModules,
        EffectsModule.forRoot([]),
        AppRoutingModule,
        ErrorModule,
        LanguageModule,
        CardScanModule,
        AdmissionDateModule,
        KioskSpinnerModule,
        PatientModule,
        InsurerModule,
        ContractModule,
        KioskModule,
        AgreementModule,
        ProvinceModule,
        CityModule,
        SiteModule,
        QuestionModule,
        LightModule,
        ArchospiModule,
        HospiModule,
        AuthenticationModule,
        TitleModule,
        StepperModule,
        MaintenanceModule,
        ScreenSaverModule,
        TransactionInfoModule,
        BackButtonDisableModule.forRoot(),
        ApiModule.forRoot({ rootUrl: environment.apiBaseUrl }),
        AuthenticatorModule.forRoot({ rootUrl: environment.authenticatorUrl })], providers: [DatePipe,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
        provideAppInitializer(() => {
        const initializerFn = (appInitializerFactory)(inject(TranslateService));
        return initializerFn();
      }), provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }

declare global {
	interface Window {
		KioPrintControler: any;
	}

	interface External {
		ShowKeyboard: Function;
		ShowKeyboardNumeric: Function;
		StartProcess: Function;
		EndProcess: Function;
		ProcessComplete: Function;
		UserIsPresent: Function;
		HideKeyboard: Function;
	}
    
}
